<template>
    <div class="__surequote-container">
      <Question :question="activeQuestion"></Question>
      <router-view name="navigation"></router-view>
    </div>
</template>

<script>
// @ is an alias to /src
import Question from '@/components/Question.vue'
import { CREATE_QUOTE_INSTANCE } from '@/store/actions.type.js';
import { finished } from 'stream';
import { mapGetters } from "vuex";

export default {
  name: 'questions',
  components: {
    Question
  },
  created(){
    this.$store.dispatch(CREATE_QUOTE_INSTANCE)
  },
  computed: {
    ...mapGetters(["activeQuestion"])
  }
}
</script>
